/**
 * @module use-cases/showcases/actions
 * @desc Auth Showcases Creators
 *
 */

import type { Showcases, ShowcasesQueryOptions } from 'core/domains';
import type { QueryOptions } from 'core/domains/catalog';
import type { AvailableShowcasesResponse } from 'core/services/bff';
import { createAction, createAsyncAction } from 'core/use-cases/utilities';

export const showcasesCleanUp = createAction<'showcasesCleanUp', string>('showcasesCleanUp');

export const showcasesFetch = createAsyncAction<
  'showcasesFetch',
  ShowcasesQueryOptions,
  Showcases['data'],
  ShowcasesQueryOptions
>('showcasesFetch');

export const availableShowcasesFetch = createAsyncAction<
  'availableShowcasesFetch',
  QueryOptions,
  AvailableShowcasesResponse
>('availableShowcasesFetch');
